// 此文件由脚本自动生成，请勿直接修改。
// This file was generated automatically by a script. Please do not modify it directly.

import { TransferTokens } from './type';

const transferTokens: TransferTokens = {
  transferFontSize: '14/regular',
  transferHeaderHeight: 'Size-23',
  transferSmallFontSize: '12/regular',
  transferSmallHeaderHeight: 'Size-22',
  transferLargeFontSize: '16/regular',
  transferLargeHeaderHeight: 'Size-24',
  transferBorderColor: 'Neutral-border-1',
  transferFontColor: 'Neutral-text-5',
  transferIconColor: 'Neutral-text-4',
  transferDisabledFontColor: 'Neutral-text-2',
  transferEmptyFontColor: 'Neutral-text-3',
  transferBorderRadius: 'Radius-4',
  transferHeaderBackgroundColor: 'Neutral-fill-2',
  transferIconBackgroundColor: 'Neutral-fill-3',
  transferIconNearlyMargin: 'Margin-8',
  transferItemHoverBackgroundColor: 'Neutral-fill-2',
  transferCheckboxHoverBackgroundColor: 'Neutral-fill-3',
};

export default transferTokens;
